import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import { Drawer } from 'antd'
// import { backgroundStyle, getThemeData, isDarkMode, textColorStyle } from '../../utils/util'

interface DrawerContext {
  content?: React.ReactNode,
  isOpen?: boolean,
  onPresent: (content: React.ReactNode) => void,
  onDismiss: () => void
}

export const Context = createContext<DrawerContext>({
  onPresent: () => {},
  onDismiss: () => {},
})

const Drawers: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [content, setContent] = useState<React.ReactNode>()
  const [showWrapper,setShowWrapper] = useState(true)
  useEffect(()=>{
    console.log('isOpen',isOpen)
    if(isOpen){
      setShowWrapper(true)
    }else{
      setTimeout(()=>{
        console.log('setInterval isOpen',isOpen)
        setShowWrapper(false)
      },500)
    }
  },[isOpen])

  const handlePresent = useCallback((modalContent: React.ReactNode) => {
    setContent(modalContent)
    setIsOpen(true)
  }, [setContent, setIsOpen])

  const handleDismiss = useCallback(() => {
    setContent(undefined)
    setIsOpen(false)
  }, [setContent, setIsOpen])

  return (
    <Context.Provider value={{
      content,
      isOpen,
      onPresent: handlePresent,
      onDismiss: handleDismiss,
    }}>
      {children}
      <div style={{position:'fixed',top:0,left:0,bottom:0,width:showWrapper?'100%':0,zIndex:101}}>
        <Drawer
          // title="过期时间"
          // placement="left"
          // closable={true}
          // onClose={ handleDismiss }
          // visible={isOpen}
          // getContainer={false}
          // width={window.innerWidth>420?420:'90%'}
          // style={{ position: 'absolute',}}
          // // drawerStyle={{...textColorStyle(), ...backgroundStyle(),}}
          // // headerStyle={{...textColorStyle(),...backgroundStyle()}}
          // closeIcon={<div style={{fontSize:20,...getThemeData({color:'gray'},{color:'white'})}}>x</div>}
        >
          {/* <p>Some contents...</p> */}
          {content}
        </Drawer>
      </div>
    </Context.Provider>
  )
}

const StyledModalWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
`

const StyledModalBackdrop = styled.div`
  background-color: #00000088;
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
`

export default Drawers